import { render, staticRenderFns } from "./CalendarInternationalization.vue?vue&type=template&id=3c8b2b1c&"
import script from "./CalendarInternationalization.vue?vue&type=script&lang=js&"
export * from "./CalendarInternationalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports